// Downscales photos before uploading to Storage. Camera/phone originals
// (5000 to 6000 px, 2 to 5 MB) quickly burn the free quota and slow the site down.
const MAX_SIDE = 2000;
const QUALITY = 0.82;

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Fajl nije ispravna slika"));
    };
    img.src = url;
  });
}

const toBlob = (canvas, type) =>
  new Promise((resolve) => canvas.toBlob(resolve, type, QUALITY));

export async function resizeImage(file) {
  if (!file.type.startsWith("image/") || file.type === "image/svg+xml" || file.type === "image/gif") {
    return file;
  }
  let img;
  try {
    img = await loadImage(file);
  } catch {
    return file;
  }
  const scale = Math.min(1, MAX_SIDE / Math.max(img.width, img.height));
  if (scale === 1 && file.size < 600 * 1024) return file;

  const canvas = document.createElement("canvas");
  canvas.width = Math.round(img.width * scale);
  canvas.height = Math.round(img.height * scale);
  canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);

  // WebP keeps transparency (matters for PNG floor plans); Safari can't encode it, so fall back to JPEG/PNG.
  let blob = await toBlob(canvas, "image/webp");
  if (!blob || blob.type !== "image/webp") {
    blob = await toBlob(canvas, file.type === "image/png" ? "image/png" : "image/jpeg");
  }
  return blob && blob.size < file.size ? blob : file;
}
